import React from "react";

export default () =>
  <div className="NotFound" style={{paddingTop:100, textAlign:"center"}}>
    <h3>Sorry, page not found!</h3>
  </div>;
